/**
 * ChartMind-I (inpatient) — collection names, enums, and prompt ids.
 */

export const CHART_MIND_I_APP_ID = "chartMindI";
export const CHART_MIND_I_PATH = "/chartmind-i";
export const CHART_MIND_I_ACCESS_COLLECTION = "chartMindIAccess";
export const ADMISSIONS_COLLECTION = "admissions";
export const PLAN_SINGLETON_ID = "current";

export const ADMISSION_STATUS = {
  ACTIVE: "active",
  DISCHARGED: "discharged",
};

export const NOTE_TYPES = {
  HP: "hp",
  DAILY_PROGRESS: "dailyProgress",
  PROCEDURE: "procedure",
  TRANSFER: "transfer",
  CONSULT: "consult",
  DISCHARGE: "discharge",
};

export const NOTE_TYPE_LABELS = {
  [NOTE_TYPES.HP]: "H&P",
  [NOTE_TYPES.DAILY_PROGRESS]: "Daily Progress",
  [NOTE_TYPES.PROCEDURE]: "Procedure",
  [NOTE_TYPES.TRANSFER]: "Transfer",
  [NOTE_TYPES.CONSULT]: "Consult",
  [NOTE_TYPES.DISCHARGE]: "Discharge Summary",
};

export const NOTE_TYPE_ORDER = [
  NOTE_TYPES.HP,
  NOTE_TYPES.DAILY_PROGRESS,
  NOTE_TYPES.PROCEDURE,
  NOTE_TYPES.TRANSFER,
  NOTE_TYPES.CONSULT,
  NOTE_TYPES.DISCHARGE,
];

export const NOTE_STATUS = {
  DRAFT: "draft",
  PENDING_COSIGN: "pendingCosign",
  SIGNED: "signed",
};

export const CODE_STATUS_VALUES = [
  "Full Code",
  "DNR",
  "DNI",
  "DNR/DNI",
  "AND / Comfort Care",
];

export const CARE_TEAM_ROLES = ["attending", "consultant", "resident", "app"];

export const MED_SNAPSHOT_TYPES = {
  ADMISSION: "admission",
  IN_HOSPITAL_CHANGE: "inHospitalChange",
  DISCHARGE: "discharge",
};

export const MED_CHANGE_ACTIONS = {
  ADDED: "added",
  STOPPED: "stopped",
  CHANGED: "changed",
};

export const DIAGNOSTIC_ORDER_STATUS = {
  ORDERED: "ordered",
  IN_PROGRESS: "inProgress",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
};

export const DIAGNOSTIC_SOURCE_SYSTEM = {
  MANUAL: "manual",
};

export const RESULT_INPUT_METHODS = {
  DICTATED: "dictated",
  TYPED: "typed",
  SELECTED: "selected",
};

export const RESULT_COMMENT_TAGS = {
  REASSURING: "reassuring",
  NORMAL: "normal",
  ABNORMAL_ACTIONED: "abnormalActioned",
  ABNORMAL_PENDING: "abnormalPending",
};

export const RESULT_COMMENT_TAG_LABELS = {
  [RESULT_COMMENT_TAGS.REASSURING]: "Reassuring",
  [RESULT_COMMENT_TAGS.NORMAL]: "Normal",
  [RESULT_COMMENT_TAGS.ABNORMAL_ACTIONED]: "Abnormal — actioned",
  [RESULT_COMMENT_TAGS.ABNORMAL_PENDING]: "Abnormal — pending",
};

export const PLAN_STATUS = {
  PENDING_REVIEW: "pendingReview",
  REVIEWED: "reviewed",
};

/**
 * Query Manager / llmGlobalPrompts ids.
 * Category uses existing `chartmind` (not a new QUERY_CATEGORIES key) until
 * the owner confirms a dedicated `chartmind-i` category.
 */
export const CHART_MIND_I_PROMPT_CATEGORY = "chartmind";
export const CHART_MIND_I_PLAN_PROMPT_ID = "chartmind-i-plan";
export const CHART_MIND_I_DISCHARGE_PROMPT_ID = "chartmind-i-discharge-summary";

/**
 * Nullable FHIR-oriented external ids (unset until an EHR adapter writes them).
 * Conceptual maps: Encounter / DocumentReference / ServiceRequest /
 * Observation / MedicationStatement.
 */
export const EXTERNAL_ID_FIELDS = {
  ADMISSION_ENCOUNTER: "externalEncounterId",
  NOTE_DOCUMENT: "externalDocumentId",
  ORDER_SERVICE_REQUEST: "externalOrderId",
  RESULT_OBSERVATION: "externalObservationId",
  MED_STATEMENT: "externalStatementId",
};

export const DEFAULT_DIAGNOSTIC_PRESETS = [
  "CBC within expected range",
  "BMP within expected range",
  "Imaging without acute finding",
  "Culture pending",
];
